import { formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import { LogSearchService } from '../services/log-search.service';
import { FILE_PREVIEW_DIALOG_DATA } from '../cdk-overlay-injector';
import { internalCdkOverlayRef } from '../cdk-overlay-ref';
import { OverlayService } from '../services/overlay.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import * as moment from 'moment-timezone';
import { SharedService } from 'src/app/services/shared.service';
@Component({
  selector: 'app-time-panel',
  templateUrl: './time-panel.component.html',
  styleUrls: ['./time-panel.component.scss']
})
/*
<------- On Initialization ------->
    *   get the time panel meta data from 'loginService'
    *   get the default values of the time panel from  'loginService'
    *   create new form group for 'range', 'from' and 'to' date-time picker
    *   subscribe the 'range' fom control
        *   if reveived data is "between", then
            *   enable the 'to'  date-time picker
        *   if reveived data is not "between", then
            *   disable the 'to'  date-time picker
<------- On Do check lifecycle ------->
    *   from the @Input get the reference of the 'time panel' component
    *   get the 'x' and 'left' points of the component using 'getBoundingClientRect' method
    *   the 'x' represents the position of the downward arrow shown above the panel
    *   the 'left' represents the position of the panel
    *   the difference between 'x' and 'left' is assigned as the css property 'left' of the upward arrow shown above the tine panel dropdown
<------- when any elative or surrounding time is clicked ------->
    *   call 'relativeTime_click' method
        *   send the dispay value of the selected predefined time to parent using 'timeEmitter' emiter
        *   call the emitter 'closePanel' to let know the parent to close the dropdown
<------- when the navigation key is pressed when the focus is on the relative or surrounding time ------->
    *   call 'navigateCells' method
        *   get the focused element
        *   if 'arrow down' is pressed, then
            *   if there is no next element for the focused element, then
                *   if relative time section is opened, then
                    *   open time range expansion
                *   if surrounding time section is opened, then
                    *   open relative time expansion
                *   if surrounding and relative time section is not opened, then
                    *   close surrounding time expansion
            *   focus on next element
        *   if 'arrow up' is pressed, then
            *   if there is no next element for the focused element, then
                *   if relative time section is opened, then
                    *   open surrounding time expansion
                *   if surrounding time section is opened, then
                    *   open time range expansion
                *   if surrounding and relative time section is not opened, then
                    *   open relative time expansion
            *   focus on next element
        *   if 'arrow left' is pressed, then
            *   if relative time section is opened, then
                *   open surrounding time expansion
            *   if surrounding time section is opened, then
                *   open time range expansion
        *   if 'arrow right' is pressed, then
            *   if relative time section is opened, then
                *   open time range expansion
            *   if surrounding time section is opened, thening 'toISOString' method
                *   remove 'T' in between date-tim
                *   open relative time expansion
<------- when the apply button in time range section is clicked ------->
    *   call 'newDateRange_click' method
        *   get new start date-time from 'from' date-time picker
            *   call 'dateFormatter' to format the date
                *   convert dat-time to ISO time use
        *   get new end date-time from 'to' date-time picker
            *   call 'dateFormatter' to format the date
        *   get the first time (01-01-1970 00:01) for 'before' option
            *   call 'dateFormatter' to format the date
        *   get current date-time
        *   if selected range is "between"
            *   send 'from'  and 'to' date-time to parent using 'timeEmitter' to display the selected range and for the search request
        *   if selected range is "since"
            *   send since and 'from' date-time to parent using 'timeEmitter' to display the selected range and for the search request
            *   the time range is selected time to current time
        *   if selected range is "before"
            *   send before and 'from' date-time to parent using 'timeEmitter' to display the selected range and for the search request
            *   the time range is first date-time to selected time
*/
export class TimePanelComponent implements OnInit {
  timeMetaData = this.logSearchService.logSearchMetaData.common_top_bar.search_bar;

  defaultTimeRange = {
    default_range: "between",
    from: this.timezoneservice.getcurrentuserTime().set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm'),
    to: this.timezoneservice.getcurrentuserTime().format('YYYY-MM-DD HH:mm')
  }

  mindate: string = this.timezoneservice.toUserTimeZone(this.sharedService.timeRange.event_time_range[0]).format('YYYY-MM-DD HH:mm:ss');
  applyclicked: boolean = false;
  fromDateState: boolean = true;
  toDateState: boolean = true;
  valuerequired: boolean = false;
  timepannelErrormsg = this.sharedService.metaData.alert.factsheetMeta.timepannelOptions.errormsg;

  selectTime = this.fb.group({
    selectRange: new UntypedFormControl(this.defaultTimeRange.default_range, Validators.required),
    fromDate: new UntypedFormControl(this.defaultTimeRange.from, Validators.required),
    toDate: new UntypedFormControl(this.defaultTimeRange.to, Validators.required),
  }, { validators: [this.creatDateRangeValidator()] }); //form group for date-time picker
  // to decide how many input field is required
  arrowPosition = this.data[1]//down arrow element in search bar near time
  selectedTimeRange = this.data[0] //the selected time range from parent component
  mode = this.data[2]
  maxdate = this.timezoneservice.getcurrentuserTime().format('YYYY-MM-DD HH:mm:ss');
  minidate = this.timezoneservice.toUserTimeZone(this.sharedService.timeRange.alert_time_range[0]).format('YYYY-MM-DD HH:mm:ss');
  //to manipulate expansion panel manually
  @ViewChild('timeRange') timeRangePanel: MatExpansionPanel;
  @ViewChild('relativeTime') relativeTimePanel: MatExpansionPanel;
  @ViewChild('surroundingTime') surroundingTimePanel: MatExpansionPanel;
  @ViewChildren('range', { read: ElementRef }) rangeSelector: QueryList<ElementRef>

  //to close the time panel when escape is pressed
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key == 'Escape') {
      this.overLayRef.close();
    }
  }
  constructor(
    public logSearchService: LogSearchService,
    private fb: UntypedFormBuilder,
    @Inject(FILE_PREVIEW_DIALOG_DATA) public data: any,
    private overLayRef: internalCdkOverlayRef,
    private dropdown: OverlayService,
    public sharedService: SharedService,
    private timezoneservice: TimeZoneService
  ) { }

  ngOnInit(): void {
    this.selectRange.valueChanges.subscribe(data => {
      this.selectTime.controls.fromDate.reset(this.defaultTimeRange.from);
      this.selectTime.controls.toDate.reset(this.defaultTimeRange.to);
      this.checkSelectRange(data);
      this.valuerequired = false;
    });
    let selectedRange: RegExp = new RegExp("^[a-zA-Z]+");
    //to add the non relative times to the date picker
    if (this.selectedTimeRange.value[3] != 0) {
      this.selectRange.patchValue(this.selectedTimeRange.disp.match(selectedRange)[0].toLowerCase());
      this.selectTime.controls.fromDate.patchValue(this.selectedTimeRange.value[0]);
      this.selectTime.controls.toDate.patchValue(this.selectedTimeRange.value[1]);
    }
  }

  diffMonths(sDate: any, eDate: any) {
    let monthDiff = (12 * (eDate.year() - sDate.year()));;
    monthDiff -= sDate.month();
    monthDiff += eDate.month();
    return monthDiff + 1
  }

  creatDateRangeValidator(): ValidatorFn {
    return (form: FormGroup): ValidationErrors | null => {
      const start = this.timezoneservice.setcurrentuserTime(form.get("fromDate").value);
      const end = this.timezoneservice.setcurrentuserTime(form.get("toDate").value);
      let currentdate = this.timezoneservice.getcurrentuserTime();
      const errobj = {};
      if (this.selectTime) {
        if (this.selectRange.value == "between") {
          if (start && end) {
            const isRangeValid = end.unix() - start.unix() > 0;
            const isMonthValid = this.diffMonths(start, end) <= 12;
            const isEndDatevalid = currentdate.unix() - end.unix() >= 0;
            if (!isRangeValid) {
              errobj['invalidtimerange'] = true;
            }
            if (!isMonthValid) {
              errobj['maximumtimerange'] = true;
            }
            if (!isEndDatevalid) {
              errobj['invalidendtime'] = true;
            }
            return errobj;
          }
        } else if (this.selectRange.value == "since") {
          if (this.selectTime.controls.fromDate.value) {
            const isRangeValid = currentdate.clone().unix() - start.unix() > 0;
            const isMonthValid = this.diffMonths(start, currentdate.clone()) <= 12;
            if (!isRangeValid) {
              errobj['invalidtimerange'] = true;
            }
            if (!isMonthValid) {
              errobj['maximumtimerange'] = true;
            }
            return errobj;
          } else {
            errobj['required'] = true;
            return errobj;
          }

        } else if (this.selectRange.value == "before") {
          if (this.selectTime.controls.toDate.value) {
            const isRangeValid = (end.unix() - this.timezoneservice.setcurrentuserTime(this.mindate).unix() > 0);
            const isMonthValid = (this.diffMonths(this.timezoneservice.setcurrentuserTime(this.mindate), end) <= 12);
            const isEndDatevalid = currentdate.unix() - end.unix() >= 0;
            if (!isRangeValid) {
              errobj['invalidtimerange'] = true;
            }
            if (!isMonthValid) {
              errobj['maximumtimerange'] = true;
            }
            if (!isEndDatevalid) {
              errobj['invalidendtime'] = true;
            }
            return errobj;
          }
          else {
            errobj['required'] = true;
            return errobj;
          }
        }
      }
      return null;
    }
  }

  relativeTime_click(time) {
    this.dropdown._time.next(time);
    this.overLayRef._time.next(time);
    this.overLayRef.close()
  }
  //move around the time panel using navigation keys
  navigateCells(event) {
    const activeElement = document.activeElement; //the element which is focused at the instance
    if (event.key == "ArrowDown") {//if arrowdown key is pressed
      if (activeElement.nextElementSibling == null) {//if there is no next list element available
        (activeElement as HTMLElement).focus()
      }
      else (activeElement.nextElementSibling as HTMLElement).focus();//if there exist next list element, then 
    }

    else if (event.key == "ArrowUp") {//if arrowup key is pressed
      if (activeElement.previousElementSibling == null) {//if there is no next list element available
        (activeElement as HTMLElement).focus()
      }
      else (activeElement.previousElementSibling as HTMLElement).focus();//if there exist next list element, then 
    }
    else if (event.key == "ArrowLeft") {//if arrowleft key is pressed
      if (this.relativeTimePanel.expanded) {//if relative time options is expanded
        this.timeRangePanel.open();  //expand surrounding time panel
      }
      else if (this.timeRangePanel.expanded) {//if surrounging time options is expanded
        this.relativeTimePanel.open(); //expand date-time range picker panel
      }
    }
    else if (event.key == "ArrowRight") {//if arrowright key is pressed
      if (this.relativeTimePanel.expanded) {//if relative time options is expanded
        this.timeRangePanel.open(); //expand date-time range picker panel
      }
      else if (this.timeRangePanel.expanded) {//if surrounging time options is expanded
        this.relativeTimePanel.open();  //expand relative time options panel
      }
    }
  }
  get selectRange() {
    return this.selectTime.get('selectRange') as UntypedFormControl
  }

  newDateRange_click() {
    this.applyclicked = true;
    if (!this.selectTime.errors) {
      // var startTime = formatDate(new Date(this.selectTime.controls.fromDate.value), 'yyyy MMM dd HH:mm:ss', 'en-US')
      var startTime = this.timezoneservice.setcurrentuserTime(this.selectTime.controls.fromDate.value).format('YYYY-MM-DD HH:mm:ss')
      var endTime = this.timezoneservice.setcurrentuserTime(this.selectTime.controls.toDate.value).format('YYYY-MM-DD HH:mm:ss')
      var startTimeDisp = this.timezoneservice.setcurrentuserTime(this.selectTime.controls.fromDate.value).format('DD MMM YYYY HH:mm:ss')
      var endTimeDisp = this.timezoneservice.setcurrentuserTime(this.selectTime.controls.toDate.value).format('DD MMM YYYY HH:mm:ss')
      var allTime = this.logSearchService.timeRangeCalc(this.timeMetaData.time_panel.relative_time_options.filter((value) => value.disp == "All Time")[0].value)
      var FirstTime = this.timezoneservice.setcurrentuserTime(allTime[0])
      var currentTime = this.timezoneservice.getcurrentuserTime(); //current time
      var selectedRange
      //to get the display name of the range selected
      this.timeMetaData.time_panel.date_time_range_options.map((data) => {
        if (data.value == this.selectRange.value)
          selectedRange = data
      })

      if (this.selectRange.value == "between") {
        this.dropdown._time.next({ "disp": selectedRange.disp + " " + startTimeDisp + " and " + endTimeDisp, "value": [startTime, endTime] })
        this.overLayRef._time.next({ "disp": selectedRange.disp + " " + startTimeDisp + " and " + endTimeDisp, "value": [startTime, endTime] })
      }
      else if (this.selectRange.value == "since") {
        this.dropdown._time.next({ "disp": selectedRange.disp + " " + startTimeDisp, "value": [startTime, endTime] })
        this.overLayRef._time.next({ "disp": selectedRange.disp + " " + startTimeDisp, "value": [startTime, endTime] })
      }
      else if (this.selectRange.value == "before") {
        this.dropdown._time.next({ "disp": selectedRange.disp + " " + startTimeDisp, "value": [this.timezoneservice.setcurrentuserTime(this.mindate).format('YYYY-MM-DD HH:mm:ss'), endTime] })
        this.overLayRef._time.next({ "disp": selectedRange.disp + " " + startTimeDisp, "value": [this.timezoneservice.setcurrentuserTime(this.mindate).format('YYYY-MM-DD HH:mm:ss'), endTime] })
      }
      this.overLayRef.close()
    }
  }

  checkSelectRange(data: string) {
    if (data == 'since') {
      this.fromDateState = true;
      this.toDateState = false;
      this.selectTime.controls.fromDate.reset();
    }
    else if (data == 'before') {
      this.toDateState = true;
      this.fromDateState = false;
      this.selectTime.controls.toDate.reset();
    } else {
      this.fromDateState = true;
      this.toDateState = true;
    }
  }

  getContainerSize() {
    if (this.mode == 1) {
      return {
        "height": "32vh",
        "width": "68vh"
      }
    }
    else if (this.mode == 2) {
      return {
        "height": "28vh",
        "width": "50vh"
      }
    }
  }

}